import {initializeAlpine} from './alpineInit';
import WidgetRegistrySingleton from "./utils/widgetRegistrySingleton";
import WizardResult from "./widgets/WizardResult";

initializeAlpine();
const widgetRegistry = WidgetRegistrySingleton.getInstance();
widgetRegistry.registerWidgetClass('WizardResultWidget', WizardResult);
widgetRegistry.initializeWidgets();
console.log('Initialized widgets!');